import {
  SHIPPING_DOMAIN,
  SHIPPING_KEY
} from 'modules/shipping/redux/constants'
import joinPathsStrUtil from 'utils/string/join-paths'
import isLoadedReduxSelector from 'modules/redux/selectors/is-loaded'

const isDeliveryAvailabilityLoadedShippingSelect = state => {
  const path = joinPathsStrUtil(SHIPPING_DOMAIN, SHIPPING_KEY.DELIVERY_AVAILABILITY)
  return isLoadedReduxSelector(path)(state)
}

export default isDeliveryAvailabilityLoadedShippingSelect
